import React from 'react'
import {BillingInfoProvider} from './billing-info-context'
import {PaymentAddressProvider} from './payment-address-context'
import {PaymentCheckboxesProvider} from './payment-checkboxes-context'
import {PaymentCardProvider} from './payment-card-context'
import {PaymentBankAccountProvider} from './payment-bank-account-context'
import {PaymentBecsBankAccountProvider} from './payment-becs-bank-account-context'
import {RecurlyPaymentProvider} from './recurly-payment-context'

export function PaymentInformationProvider({children}) {
  return (
    <RecurlyPaymentProvider>
      <BillingInfoProvider>
        <PaymentAddressProvider>
          <PaymentCardProvider>
            <PaymentBankAccountProvider>
              <PaymentBecsBankAccountProvider>
                <PaymentCheckboxesProvider>
                  {children}
                </PaymentCheckboxesProvider>
              </PaymentBecsBankAccountProvider>
            </PaymentBankAccountProvider>
          </PaymentCardProvider>
        </PaymentAddressProvider>
      </BillingInfoProvider>
    </RecurlyPaymentProvider>
  )
}
